<template>
    <v-card v-if="loading">
        <v-progress-linear height="10" indeterminate />
    </v-card>
    <v-card style="background-color: transparent" elevation="0" class="mx-0" v-else>
        <v-card-text class="no-padding">
            <v-row no-gutters v-if="wizardStep !== 0" class="my-3">
                <v-col cols="3" class="d-flex align-center">
                    <v-btn-icon
                        variant="flat"
                        icon="$navigate_before"
                        elevation="0"
                        color="primary"
                        size="x-small"
                        @click="previous()"
                    />
                    <v-select
                        class="pl-3"
                        hide-details
                        outlined
                        v-model="selectedUserId"
                        :items="users"
                        :item-props="true"
                        :item-title="(item) => getUserDisplayName(item)"
                        item-value="id"
                        label="Signataire"
                        :disabled="wizardStep === 2"
                        :loading="stockInventoriesLoading"
                        density="compact"
                    >
                        <template #item="{ props }">
                            <v-list-item class="oss-list-item" v-bind="props">
                                <template #prepend>
                                    <v-avatar color="secondary" size="small">{{
                                        getUserBigram(props)
                                    }}</v-avatar>
                                </template>
                            </v-list-item>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="2" class="pl-2">
                    <!-- <oss-date-picker
                        v-model="date"
                        type="month"
                        format="MM/YYYY"
                        outlined
                        :text-field-readonly="false"
                        :minDate="selectedAccountingPeriod && selectedAccountingPeriod.start"
                        :maxDate="selectedAccountingPeriod && selectedAccountingPeriod.end"
                        :disabled="selectedAccountingClosing && selectedAccountingClosing.id !== ''"
                        hide-details="auto"
                        @change-date="onDateChanged"
                    ></oss-date-picker> -->
                    <oss-date-picker
                        v-model="date"
                        :text-field-readonly="false"
                        hide-details="auto"
                        :disabled="wizardStep === 2"
                        @change-date="onDateChanged"
                    />
                </v-col>
                <v-col cols="3" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        label="&#xc9;tat"
                        hide-details
                        :model-value="selectedStatus.text"
                        density="compact"
                    />
                </v-col>
                <v-spacer />
                <v-col cols="1" v-if="wizardStep === 2" class="d-flex align-center justify-center">
                    <v-tooltip location="bottom">
                        <template #activator="{ props }">
                            <v-btn-icon
                                icon="$oss-download"
                                elevation="0"
                                density="compact"
                                v-bind="props"
                                @click="printInventory"
                                :disabled="disabledDownload()"
                                :loading="downloadLoading"
                                style="margin-left: 4px; margin-right: 4px"
                            />
                        </template>
                        <span>Télécharger</span>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template #activator="{ props }">
                            <v-btn-icon
                                :icon="!showDocumentPreview ? '$oss-eye' : '$oss-edit'"
                                @click="showDocumentPreview = !showDocumentPreview"
                                v-bind="props"
                                density="compact"
                                style="margin-left: 4px; margin-right: 4px"
                            />
                        </template>
                        <span v-if="!showDocumentPreview">Prévisualiser le document</span>
                        <span v-else>Afficher la liste</span>
                    </v-tooltip>
                </v-col>
                <v-col v-if="wizardStep === 1" cols="2" class="d-flex align-center justify-end">
                    <v-btn
                        rounded
                        elevation="0"
                        @click="saveInventory()"
                        :disabled="disabledValid"
                        size="small"
                    >
                        {{ selectedInventoryId ? "Sauvegarder" : "Enregistrer" }}
                    </v-btn>
                </v-col>
                <v-col v-if="wizardStep === 2" cols="3" class="d-flex align-center justify-end">
                    <v-btn
                        rounded
                        elevation="0"
                        @click="wizardStep = 1"
                        :disabled="selectedStatus.value === 'VALIDATED'"
                        class="mx-2"
                        size="small"
                    >
                        &#xc9;diter
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        rounded
                        elevation="0"
                        :disabled="selectedStatus.value === 'VALIDATED'"
                        @click="validateInventory()"
                        class="mx-2"
                        size="small"
                    >
                        Valider l'inventaire
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="wizardStep !== 0 && reverseError" no-gutters>
                <v-col cols="12" class="px-1">
                    <v-alert
                        dismissible
                        type="warning"
                        @update:model-value="reverseError = false"
                        :model-value="reverseError"
                        density="compact"
                    >
                        {{ errorList[errorIndex] }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-window
                v-model="wizardStep"
                touchless
                class="elevation-0"
                style="background: transparent"
            >
                <v-window-item :value="0">
                    <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                        <v-col cols="2">
                            <v-menu location="end">
                                <template #activator="{ props }">
                                    <v-btn-primary
                                        v-bind="props"
                                        block
                                        data-cy="invoices-new-invoice"
                                    >
                                        Ajouter
                                    </v-btn-primary>
                                </template>

                                <v-list nav density="compact">
                                    <v-list-item
                                        @click="startNewInventory(true)"
                                        title="Inventaire à remplir"
                                    >
                                        <template #append>
                                            <v-icon
                                                icon="$oss-edit"
                                                size="small"
                                                location="start"
                                            />
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="startNewInventory(false)"
                                        title="Inventaire pré-rempli"
                                    >
                                        <template #append>
                                            <v-icon
                                                icon="$oss-edit"
                                                size="small"
                                                location="start"
                                            />
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                        <!-- <v-col cols="2" class="pl-2 d-flex">
                            <v-btn
                                color="secondary"
                                elevation="0"
                                height="40px"
                                class="rounded-lg gradient"
                                block
                                :disabled="true"
                                data-cy="invoices-send-mails"
                            >Envoyer par mail</v-btn>
                        </v-col> -->
                        <v-col cols="10" class="pl-2">
                            <v-text-field
                                v-model="search"
                                append-inner-icon="$fa-search"
                                clearable
                                @click:clear="search = ''"
                                label="Recherche"
                                regular
                                outlined
                                hide-details
                                autofocus
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-data-table
                        :headers="inventoryHeaders"
                        :items="inventories"
                        :items-per-page-options="itemsPerPageOptions"
                        fixed-header
                        max-height="60vh"
                        :multi-sort="false"
                        class="table"
                    >
                        <template v-slot:item="{ item }">
                            <tr data-cy="invoices-invoice" @click="openInventory(item.id)">
                                <td>{{ formatDate(item.date) || "-" }}</td>
                                <td>
                                    {{ item.signer.firstname + " " + item.signer.lastname || "-" }}
                                </td>
                                <td>
                                    {{ item.accountingClosing ? item.accountingClosing.name : "-" }}
                                </td>
                                <td>{{ "-" }}</td>
                                <td>
                                    <v-chip size="small" label>
                                        <v-icon
                                            icon="$labl_icon"
                                            size="small"
                                            style="margin-right: 4px"
                                        />
                                        {{ item.status === "EDITION" ? "Brouillon" : "Validé" }}
                                    </v-chip>
                                </td>
                                <td>
                                    <v-btn-trash
                                        x-small
                                        @click.stop="selectInventoryForDeletion(item)"
                                    />
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-window-item>
                <v-window-item :value="1">
                    <v-data-table
                        :headers="stockHeaders"
                        :items="stockLines"
                        class="table strong-border"
                        fixed-header
                        max-height="60vh"
                        :multi-sort="false"
                        :loading="stockLinesLoading"
                        :no-data-text="'Aucun produit ajouté'"
                        hide-default-footer
                    >
                        <template v-slot:item="{ item, index }">
                            <tr
                                v-if="item.show"
                                data-cy="stockOperations-stock"
                                :style="getRowStyle(item)"
                            >
                                <template v-if="item.father">
                                    <td class="text-xs-right">
                                        <v-btn-icon
                                            v-if="item.father"
                                            :icon="
                                                item.expand
                                                    ? '$keyboard_arrow_up'
                                                    : '$keyboard_arrow_down'
                                            "
                                            @click="handleVisibility(item)"
                                        />
                                    </td>
                                    <td>{{ item.invoiceProduct.title || "-" }}</td>
                                    <td>{{ item.invoiceProduct.reference || "-" }}</td>
                                    <td>{{ item.stockAccount.name || "-" }}</td>
                                    <td class="text-right">{{ item.quantity }}</td>
                                    <td class="text-right">
                                        {{ newCommonFormatCurrency(item.totalAmount, undefined) }}
                                    </td>
                                    <td class="text-right">
                                        {{
                                            newCommonFormatCurrency(
                                                item.stockAmountSigned,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td class="text-right">
                                        {{
                                            newCommonFormatCurrency(
                                                item.depreciatedAmountSigned,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td class="text-center pl-3 pb-2">
                                        <v-btn-trash @click="deleteRow(index, 3)" size="x-small" />
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="text-xs-right" />
                                    <td>{{ item.invoiceProduct.title || "-" }}</td>
                                    <td>{{ item.invoiceProduct.reference || "-" }}</td>
                                    <td>{{ item.stockAccount.name || "-" }}</td>
                                    <td class="align-center">
                                        <oss-text-field-filled
                                            :hide-details="true"
                                            class="ml-2 righted-input"
                                            v-model="item.quantity"
                                            @change="onQuantityChanged(item)"
                                        />
                                    </td>
                                    <td class="text-right">
                                        {{
                                            newCommonFormatCurrency(item.totalAmount, undefined) ||
                                            ""
                                        }}
                                    </td>
                                    <td class="align-center">
                                        <oss-text-field-filled
                                            :hide-details="true"
                                            suffix="&#x20ac;"
                                            class="ml-2 righted-input"
                                            v-model="item.stockAmountSigned"
                                            @change="onAmountsChanged(item)"
                                        />
                                    </td>
                                    <td class="align-center">
                                        <oss-text-field-filled
                                            :hide-details="true"
                                            suffix="&#x20ac;"
                                            class="ml-2 righted-input"
                                            v-model="item.depreciatedAmountSigned"
                                            :error="item.variableAmountError"
                                            @change="onAmountsChanged(item)"
                                        />
                                    </td>
                                    <td class="text-center pl-3 pb-2">
                                        <v-btn-trash
                                            v-if="item.childOf === null"
                                            @click="deleteRow(index, 1)"
                                            size="x-small"
                                        />
                                    </td>
                                </template>
                            </tr>
                        </template>

                        <template v-slot:body.append>
                            <tr class="mx-2">
                                <td />
                                <td class="align-center">
                                    <v-text-field-filled
                                        :hide-details="true"
                                        outlined
                                        v-model="newStockLine.title"
                                        density="compact"
                                    />
                                </td>
                                <td class="align-center">
                                    <v-text-field-filled
                                        :hide-details="true"
                                        outlined
                                        v-model="newStockLine.reference"
                                        density="compact"
                                    />
                                </td>
                                <td class="align-center">
                                    <v-select-filled
                                        hide-details
                                        outlined
                                        style="pointer-events: auto"
                                        v-model="newStockLine.stockAccount1"
                                        :items="stock_names"
                                        return-object
                                        class="v-select-font-size"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </td>
                                <!-- <td>{{ item.stockAccount.name || "-" }}</td>
                                <td>{{ item.inventoryAccount.name || "-" }}</td> -->
                                <td class="align-center">
                                    <oss-text-field-filled
                                        :hide-details="true"
                                        class="ml-2 righted-input"
                                        v-model="newStockLine.quantity"
                                    />
                                </td>
                                <td />
                                <td class="align-center">
                                    <oss-text-field-filled
                                        :hide-details="true"
                                        suffix="&#x20ac;"
                                        class="ml-2 righted-input"
                                        v-model="newStockLine.stockAmountSigned"
                                    />
                                </td>
                                <td class="align-center">
                                    <oss-text-field-filled
                                        :hide-details="true"
                                        suffix="&#x20ac;"
                                        class="ml-2 righted-input"
                                        v-model="newStockLine.depreciatedAmountSigned"
                                        :error="newStockLine.variableAmountError"
                                    />
                                </td>
                                <td class="text-center pl-3 pb-2">
                                    <v-btn-icon
                                        variant="flat"
                                        icon="$add"
                                        size="small"
                                        @click="addRow()"
                                        :disabled="disabledAdd"
                                        elevation="0"
                                        color="primary"
                                    />
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-window-item>
                <v-window-item :value="2">
                    <v-row no-gutters>
                        <v-spacer />
                        <v-col cols="8" class="py-2">
                            <InvoiceHtmlTemplateView
                                v-if="showDocumentPreview"
                                ref="invoicePreviewRef"
                                :invoiceThemeSettings="invoiceThemeSettings"
                                :invoiceData="previewData"
                                :quotation="null"
                                :forPrint="false"
                                :company="companyFullData"
                                :backgroundImage="backgroundImage"
                                :additionalDocument="additionalDocument"
                                @dom-info="invoiceDomInfo = $event"
                                hideExtraDocument
                            />
                        </v-col>
                        <v-spacer />
                    </v-row>
                    <v-data-table
                        v-show="!showDocumentPreview"
                        :headers="stockHeaders.slice(0, 8)"
                        :items="stockLines"
                        class="table"
                        fixed-header
                        max-height="60vh"
                        :multi-sort="false"
                    >
                        <template v-slot:item="{ item, index }">
                            <tr
                                v-if="!item.father && item.quantity"
                                data-cy="stockOperations-stock"
                            >
                                <td />
                                <td>{{ item.invoiceProduct.title || "-" }}</td>
                                <td>{{ item.invoiceProduct.reference || "-" }}</td>
                                <td class="text-center">{{ item.stockAccount.name || "-" }}</td>
                                <td class="text-center">{{ item.quantity || "-" }}</td>
                                <td class="text-center">{{ item.totalAmount || "-" }}</td>
                                <td class="text-center">{{ item.stockAmountSigned || "0" }}</td>
                                <td class="text-center">
                                    {{ item.depreciatedAmountSigned || "0" }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-window-item>
            </v-window>
        </v-card-text>
        <!-- <v-card-actions v-if="wizardStep !== 0">
            <v-btn  size="small"  rounded elevation="0" color="secondary" @click="previous()">Précédent</v-btn>
            <v-spacer></v-spacer>
            <v-btn  size="small"  rounded elevation="0" @click="saveInventory()" :disabled="disabledValid">
                {{selectedInventoryId ? 'Sauvegarder' : 'Valider' }}
            </v-btn>
        </v-card-actions> -->
        <oss-dialog
            title="Confirmation"
            v-model="dialogConfirmInventory"
            @valid="
                confirmInventory();
                dialogConfirmInventory = false;
            "
            max-width="40vw"
        >
            <div>
                Voulez-vous vraiment valider ce document ? Cette action ne peut pas être annulée
            </div>
        </oss-dialog>
        <oss-dialog title="Attention" v-model="negativeStockDialog" max-width="40vw">
            <div>Vous avez une valeur négative en stock, veuillez vérifier</div>
        </oss-dialog>
        <oss-dialog
            v-model="deleteInventoryDialog"
            v-if="inventoryToDeleteId"
            title="Suppression de l'inventaire"
            @valid="deleteInventory(inventoryToDeleteId)"
            :validLoading="deleteInventoryLoading"
            width="550px"
        >
            <h4 class="text-center">
                &#xc9;tes-vous sûr(e) de vouloir supprimer cet inventaire ? Cette action est
                irréversible
            </h4>
        </oss-dialog>
    </v-card>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { State2Way } from "@/decorators";

import moment from "moment-timezone";
import { getUserBigram, getUserDisplayName } from "../../services/userServices";

import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers2.gql";
import SelectUser from "../user/SelectUser.vue";
import { stockNames } from "../../services/stockInventoryAccountRelations";

import STOCK_INVENTORY_BALANCE from "../../graphql/stock/StockInventoryBalance.gql";
import STOCK_WBAD_AMOUNTS from "../../graphql/stock/StockWriteBacksDowns.gql";
import STOCK_INVENTORY from "../../graphql/stock/StockInventory.gql";
import INVENTORY_SAVE from "../../graphql/stock/InventoryDraft.gql";
import INVENTORY_VALIDATE from "../../graphql/stock/ValidateInventory.gql";
import DELETE_INVENTORY from "../../graphql/stock/DeleteInventory.gql";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { User } from "../../../../types";

import getEnv from "../../env";
import axios from "axios";
import { filterAccountableAccounts } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";

import InvoiceHtmlTemplateView from "../invoiceTheme/InvoiceHtmlTemplateView.vue";
import InvoiceThemeFrontService from "@/services/invoiceThemeFrontServices";
import INVOICE_THEMES from "@/graphql/invoiceTheme/InvoiceThemes.gql";
import GET_INVOICE_THEME_BACKGROUND from "@/graphql/invoiceTheme/GetInvoiceThemeBackground.gql";
import GET_INVOICE_ADDITIONAL_DOCUMENT from "@/graphql/invoiceTheme/GetInvoiceThemeAdditionalDocument.gql";
import InventoryListHtmlBuilder from "../../../../backend/src/common/invoiceTheme/InventoryListHtmlBuilder";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        SelectUser,
        InvoiceHtmlTemplateView,
    },
    emits: ["refresh"],
})
export class InventoryWizard extends Vue {
    @Prop({ default: 0 }) step: number;
    wizardStep = 0;

    @State2Way("updateInventoryPagination", "stockFilter.inventoryPagination")
    inventoryPagination!: any;

    selectedInventoryId = "";

    isFIFO = true;

    dialogConfirmInventory = false;

    negativeStockDialog = false;

    inventoryLoading = false;

    loading: boolean = false;

    downloadLoading: boolean = false;

    emptyInventary = true;

    date: string = moment().format();

    search = "";

    stockLinesLoading = false;

    stockInventoriesLoading = false;

    reverseError = false;

    showDocumentPreview = false;

    invoiceDomInfo: any = "";

    get previewData() {
        return {
            type: "INVENTORY",
            title: "",
            company: this.companyFullData,
            lines: this.stockLines
                ?.map((line) => {
                    const type = line.stockAmountSigned
                        ? "Stock"
                        : line.depreciatedAmountSigned > 0
                          ? "Reprise"
                          : "Dépreciation";
                    const description = line.stockAccount?.description;
                    return {
                        ...line.invoiceProduct,
                        ...line,
                        grossAmount: line.totalAmount,
                        type: type,
                        description: description,
                    };
                })
                .filter((line) => line.id),
            signer: this.selectedInventorySigner,
            paymentDetails: this.companyFullData?.invoiceTextPaymentDetails,
            stockInventory: this.selectedStockInventory,
        };
    }

    errorIndex = 0;

    errorList = [
        "Aucune dépréciation antérieure n'a été provisionnée",
        "Le montant de la reprise ne doit pas être supérieur à la dotation initiale",
        "Le montant de la depréciation ne doit pas être supérieur à la valeur en stock",
    ];

    // rangeForGQL = [
    //     {name_starts_with: "33"},
    //     {name_starts_with: "34"},
    //     {name_starts_with: "35"},
    //     {name_starts_with: "713"},
    // ]

    user = { id: "", firstname: "", lastname: "" };

    emptyStockLine = {
        title: "",
        reference: "",
        productId: "",
        type: "",
        quantity: null,
        stockAmountSigned: null,
        depreciatedAmountSigned: null,
        stockAccountableAccount: null,
        inventoryChange: null,
        stockAccount1: null,
        stockAccount2: null,
    };

    newStockLine = {
        title: "",
        reference: "",
        productId: "",
        type: "",
        quantity: null,
        stockAmountSigned: null,
        depreciatedAmountSigned: null,
        variableAmountError: false,
        stockAccountableAccount: null,
        inventoryChange: null,
        stockAccount1: null,
        stockAccount2: null,
    };

    writeBacksAmounts = [];

    writeDownsAmounts = [];

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod.selectedAccountingClosing?.id
            ? this.$store.state.accountingPeriod.selectedAccountingClosing
            : undefined;
    }

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod?.id
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod
            : undefined;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get stock_names() {
        return stockNames.names;
    }

    defaultStockName = {
        name: "-",
        stockAccount: "-",
        inventoryAccount: "-",
        depreciationAccount: "-",
        type: "EXPENSE",
    };

    get inventoryHeaders(): {
        title: string;
        value: string;
        sortable?: boolean;
        align?: "start" | "center" | "end";
        width?: string;
    }[] {
        return [
            { title: "Date", value: "date", sortable: true },
            { title: "Signataire", value: "signer", sortable: true },
            { title: "Exercice comptable", value: "accountingClosing", sortable: true },
            { title: "Période comptable", value: "accountingPeriod", sortable: true },
            { title: "Statut", value: "available", width: "10%", sortable: true, align: "center" },
            { title: "", value: "action", width: "5%", sortable: false, align: "center" },
        ];
    }

    get stockHeaders(): {
        title: string;
        value: string;
        sortable?: boolean;
        align?: "start" | "center" | "end";
        width?: string;
    }[] {
        return [
            { title: "", value: "expand", sortable: false, width: "2%" },
            { title: "Produit", value: "product", sortable: true },
            { title: "Référence", value: "reference", sortable: true },
            { title: "Nom du stock", value: "stockName", sortable: true, align: "center" },
            // { title: "Compte de stock", value: 'stockAccount',sortable: true },
            // { title: "Compte de variation de stocks", value: 'inventoryAccount', sortable: true },
            {
                title: "Quantité",
                value: "available",
                width: "10%",
                sortable: true,
                align: "center",
            },
            { title: "Total", value: "total", width: "12%", sortable: true, align: "center" },
            {
                title: "Valeur stocké",
                value: "stored",
                width: "12%",
                sortable: false,
                align: "center",
            },
            {
                title: "Reprise(+) / Dépréciation(-)",
                value: "depreciated",
                width: "12%",
                sortable: false,
                align: "center",
            },
            { title: "Actions", value: "actions", sortable: false, align: "center" },
        ];
    }

    get itemsPerPageOptions() {
        return [
            { value: 10, title: "10" },
            { value: 25, title: "25" },
            { value: 50, title: "50" },
        ];
    }

    get disabledAdd() {
        if (!this.newStockLine.title) {
            return true;
        }
        if (!this.newStockLine.reference) {
            return true;
        }
        if (!this.newStockLine.quantity) {
            return true;
        }
        if (!this.newStockLine.stockAccount1.name) {
            return true;
        }
        return false;
    }

    get disabledValid() {
        if (!this.selectedUserId) {
            return true;
        }
        const inProgressLines = this.stockLines.filter((item) =>
            item.stockAccount.stockAccount.startsWith("331"),
        );
        if (
            inProgressLines.filter(
                (l) => l.quantity && !l.stockAmountSigned && !l.depreciatedAmountSigned,
            ).length
        ) {
            return true;
        }
        if (
            inProgressLines.filter(
                (l) => !l.quantity && (l.stockAmountSigned || l.depreciatedAmountSigned),
            ).length
        ) {
            return true;
        }
        if (
            this.stockLines.filter(
                (item) => !item.quantity && !item.stockAccount.stockAccount.startsWith("331"),
            ).length
        ) {
            return true;
        }
        if (
            this.stockLines.filter(
                (item) =>
                    !item.stockAmountSigned &&
                    !item.depreciatedAmountSigned &&
                    !item.stockAccount.stockAccount.startsWith("331"),
            ).length
        ) {
            return true;
        }
        if (this.stockLines.find((sl) => sl.variableAmountError) || this.reverseError) {
            return true;
        }
        return false;
    }

    getRowStyle(item) {
        return !item.expand && item.father
            ? "background: rgba(0, 0, 0, 0.1)"
            : "background: rgba(0, 0, 0, 0)";
    }

    getFilteredStockNames(type) {
        if (type === "PRODUCT") {
            return this.stock_names.filter((sn) => sn.type === "PRODUCT");
        }
        return this.stock_names;
    }

    getUserBigram(user) {
        return getUserBigram(user);
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    beforeMount() {
        if (this.wizardStep) {
            this.step = this.wizardStep;
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    formatDate(date: Date) {
        if (!date) return "-";
        return moment(date).format("DD/MM/YYYY");
    }

    isVisible(item) {
        if (item.stockAccount1.type === "PRODUCT") return "visible";
        return "hidden";
    }

    handleVisibility(item) {
        const indexer = item.indexer;
        item.expand = !item.expand;
        this.stockLines.forEach((element, index) => {
            if (element.childOf === indexer && element.indexer !== indexer) {
                element.show = !element.show;
            }
        });
    }

    async startNewInventory(value) {
        this.negativeStockDialog = false;
        this.emptyInventary = value;
        this.date = moment().format();
        if (value) {
            this.stockLines = [];
            this.wizardStep = 1;
        } else {
            if (this.stockLines.find((sl) => sl.quantity < 0)) {
                this.negativeStockDialog = true;
            } else {
                this.wizardStep = 1;
            }
        }
    }

    async openInventory(value) {
        this.selectedInventoryId = value;
        this.wizardStep = 2;
        this.date = moment().format();
    }

    onAmountsChanged(item) {
        // this.reverseError = false
        // if(item.depreciatedAmountSigned > 0) {
        //     if(this.reprises[item.stockAccount.depreciationAccount]) {
        //         this.reverseExceeded = this.reprises[item.stockAccount.depreciationAccount] > item.depreciatedAmountSigned
        //         this.reverseError = true
        //         this.errorIndex = 0
        //     } else {
        //         this.reverseError = true
        //         this.errorIndex = 0
        //     }
        // }
        item.variableAmountError = this.checkMaxWDABamounts(
            item.depreciatedAmountSigned,
            item.stockAccount.depreciationAccount,
            item.stockAccount.inventoryAccount,
            false,
        );
        if (item.childOf !== null) {
            let stockAmount = 0;
            let depreciatedAmount = 0;
            stockAmount =
                this.stockLines[item.childOf + 1].stockAmountSigned +
                this.stockLines[item.childOf + 2].stockAmountSigned;
            depreciatedAmount =
                this.stockLines[item.childOf + 1].depreciatedAmountSigned +
                this.stockLines[item.childOf + 2].depreciatedAmountSigned;
            this.stockLines[item.childOf].totalAmount = stockAmount + depreciatedAmount;
            this.stockLines[item.childOf].stockAmountSigned = stockAmount;
            this.stockLines[item.childOf].depreciatedAmountSigned = depreciatedAmount;
        } else {
            item.totalAmount = item.stockAmountSigned + item.depreciatedAmountSigned;
        }
    }

    onQuantityChanged(item) {
        if (item.childOf !== null) {
            const quantity =
                this.stockLines[item.childOf + 1].quantity +
                this.stockLines[item.childOf + 2].quantity;
            this.stockLines[item.childOf].quantity = quantity;
        }
    }

    @Apollo({
        query: gql`
            query Inventories($companyId: ID!) {
                stockInventories(where: { company: { id: $companyId } }, orderBy: date_DESC) {
                    id
                    signer {
                        id
                        firstname
                        lastname
                    }
                    date
                    status
                    accountingPeriod {
                        id
                    }
                    accountingClosing {
                        id
                    }
                    company {
                        id
                    }
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data && data.stockInventories) {
                if (data.stockInventories.length) {
                    this.inventories = data.stockInventories;
                } else {
                    this.inventories = [];
                }
            } else {
                this.inventories = [];
            }
            this.stockInventoriesLoading = false;
        },
        debounce: 500,
    })
    inventories = [];

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
                type: undefined,
                availableCompanyId: undefined,
            };
            // email_not: this.withEmail ? null:undefined,
        },
        skip() {
            return !this.companyId || !!this.outstanding;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.users) {
                    this.users = JSON.parse(JSON.stringify(data.users));
                } else {
                    this.users = [];
                }
            }
        },
    })
    users: User[] = [];

    // @Apollo({
    //     query: ACCOUNTABLE_ACCOUNTS_STARTS_WITH,
    //     variables(){
    //         return { range: this.rangeForGQL }
    //     },
    //     result({data, loading}: any) {
    //         if (!loading) {
    //             if (data && data.accountableAccounts) {
    //                 this.stockAccountableAccounts = data.accountableAccounts.filter(aa => aa.name.startsWith("3"))
    //                 this.inventoryAccountableAccounts = data.accountableAccounts.filter(aa => aa.name.startsWith("7"))
    //             } else {
    //                 console.log("AccountableAccountVue data pb");
    //             }
    //         }
    //     }
    // })
    get stockAccountableAccounts() {
        const includeRootAAs = ["33", "34", "35"];
        return filterAccountableAccounts(
            this.$store.state.accountableAccountTable,
            includeRootAAs,
            [],
        );
    }

    get inventoryAccountableAccounts() {
        const includeRootAAs = ["713"];
        return filterAccountableAccounts(
            this.$store.state.accountableAccountTable,
            includeRootAAs,
            [],
        );
    }

    @Apollo({
        query: STOCK_INVENTORY_BALANCE,
        variables() {
            return {
                selectedCompanyId: this.companyId,
                method: this.isFIFO ? "FIFO" : "WEIGHTED",
                date: moment(this.date).format(),
            };
        },
        skip() {
            return !this.companyId || this.selectedInventoryId || this.emptyInventary;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                this.stockLinesLoading = true;
                if (!this.selectedInventoryId) {
                    this.stockLines.length = 0;
                }
                if (data && data.stocksInventory) {
                    data.stocksInventory.inventory.forEach((line) => {
                        this.setStockLines(line, false);
                    });
                }
                this.stockLinesLoading = false;
            }
        },
    })
    stockLines = [];

    setStockLines(line, userEntry) {
        if (line.stockAccount1 && line.stockAccount2) {
            const fatherIndex = this.stockLines.length;
            this.stockLines.push({
                id: "",
                depreciationId: "",
                father: true,
                indexer: this.stockLines.length,
                childOf: fatherIndex,
                expand: true,
                show: true,
                invoiceProduct: {
                    title: line.title,
                    reference: line.reference,
                    id: line.productId,
                    type: line.type,
                },
                quantity: userEntry ? line.quantity : line.available,
                totalAmount: userEntry
                    ? line.depreciatedAmountSigned + line.stockAmountSigned
                    : line.residualPrice,
                stockAmountSigned: userEntry ? line.stockAmountSigned : line.residualPrice,
                depreciatedAmountSigned: userEntry ? line.depreciatedAmountSigned : 0,
                variableAmountError: false,
                stockAccount: line.stockAccount1,
            });
            // STOCK
            this.stockLines.push({
                id: "",
                depreciationId: "",
                father: false,
                indexer: this.stockLines.length,
                childOf: fatherIndex,
                expand: false,
                show: false,
                invoiceProduct: {
                    title: line.title,
                    reference: line.reference,
                    id: line.productId,
                    type: line.type,
                },
                quantity: userEntry ? line.quantity : line.available,
                stockAmountSigned: userEntry ? line.stockAmountSigned : line.residualPrice,
                depreciatedAmountSigned: userEntry ? line.depreciatedAmountSigned : null,
                variableAmountError: false,
                stockAccount: line.stockAccount1,
            });
            // DEPRECIATION
            this.stockLines.push({
                id: "",
                depreciationId: "",
                father: false,
                indexer: this.stockLines.length,
                childOf: fatherIndex,
                expand: false,
                show: false,
                invoiceProduct: {
                    title: line.title,
                    reference: line.reference,
                    id: line.productId,
                    type: line.type,
                },
                quantity: null,
                stockAmountSigned: null,
                depreciatedAmountSigned: null,
                stockAccount: line.stockAccount2,
            });
        } else {
            this.stockLines.push({
                id: "",
                depreciationId: "",
                father: false,
                indexer: this.stockLines.length,
                childOf: null,
                expand: false,
                show: true,
                invoiceProduct: {
                    title: line.title,
                    reference: line.reference,
                    id: line.productId,
                    type: line.type,
                },
                quantity: userEntry ? line.quantity : line.available,
                totalAmount: userEntry
                    ? line.depreciatedAmountSigned + line.stockAmountSigned
                    : line.residualPrice,
                stockAmountSigned: userEntry ? line.stockAmountSigned : line.residualPrice,
                depreciatedAmountSigned: userEntry ? line.depreciatedAmountSigned : null,
                stockAccount: line.stockAccount1,
            });
        }
    }

    @Apollo({
        query() {
            return STOCK_INVENTORY;
        },
        variables() {
            return {
                id: this.selectedInventoryId,
            };
        },
        // debounce: 500,
        skip() {
            return !this.selectedInventoryId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.stockInventory) {
                    this.date = moment(data.stockInventory.date).format();
                    if (data.stockInventory.status === "VALIDATED") {
                        this.selectedStatus = { value: "VALIDATED", text: "Validé" };
                    }
                    this.formatEditionLines(data.stockInventory.lines);
                    if (data.stockInventory.signer) {
                        this.selectedInventorySigner = data.stockInventory.signer;
                        this.selectedStockInventory = data.stockInventory;
                        this.selectedUserId = data.stockInventory.signer.id;
                    }
                } else {
                    this.resetData();
                }
            }
        },
    })
    selectedStatus = { value: "DRAFT", text: "Brouillon" };

    selectedUserId: string = "";
    selectedInventorySigner: any = "";
    selectedStockInventory: any = "";

    @Apollo({
        query: STOCK_WBAD_AMOUNTS,
        variables() {
            return {
                selectedCompanyId: this.companyId,
                date: moment(this.date).format(),
            };
        },
        skip() {
            return !this.companyId || this.wizardStep !== 1 || !this.date;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                this.stockLinesLoading = true;
                if (data && data.stockWriteBacksAndDowns) {
                    this.writeBacksAmounts =
                        data.stockWriteBacksAndDowns.writeBacksDownsAmounts.writeBacksAmounts;
                    this.writeDownsAmounts =
                        data.stockWriteBacksAndDowns.writeBacksDownsAmounts.writeDownsAmounts;
                }
                this.stockLinesLoading = false;
            }
        },
    })
    addRow() {
        const mainStockAccount = this.newStockLine.stockAccount1.stockAccount;
        const depreciatedStockAccount = this.newStockLine.stockAccount1.depreciationAccount;
        const inventoryStockAccount = this.newStockLine.stockAccount1.inventoryAccount;

        const variableAmount = this.newStockLine.depreciatedAmountSigned
            ? this.newStockLine.depreciatedAmountSigned
            : 0;
        this.newStockLine.variableAmountError = this.checkMaxWDABamounts(
            variableAmount,
            depreciatedStockAccount,
            inventoryStockAccount,
            true,
        );

        if (!this.newStockLine.variableAmountError) {
            this.newStockLine.type = this.newStockLine.stockAccount1.type;
            if (mainStockAccount.startsWith("355") || mainStockAccount.startsWith("351")) {
                this.newStockLine.stockAccount2 = this.stock_names.find((sn) =>
                    sn.stockAccount.startsWith("331"),
                );
            }
            this.setStockLines(this.newStockLine, true);
            this.newStockLine = JSON.parse(JSON.stringify(this.emptyStockLine));
            this.reverseError = false;
        }
    }

    checkMaxWDABamounts(variableAmount, depreciatedStockAccount, inventoryStockAccount, newLine) {
        if (variableAmount > 0) {
            // WRITE-BACK
            const sameAccounts = this.stockLines.filter(
                (sl) =>
                    sl.stockAccount.depreciationAccount === depreciatedStockAccount && !sl.father,
            );
            let addedWBamounts = sameAccounts.reduce(
                (partialSum, el) => partialSum + el.depreciatedAmountSigned,
                0,
            );
            addedWBamounts += this.writeBacksAmounts[depreciatedStockAccount]
                ? this.writeBacksAmounts[depreciatedStockAccount]
                : 0;
            // If new Line, amount not yet in stockLines
            addedWBamounts += newLine ? variableAmount : 0;
            if (addedWBamounts <= 0) {
                this.reverseError = false;
                return false;
            }
            this.reverseError = true;
            if (this.writeBacksAmounts[depreciatedStockAccount] === null) {
                this.errorIndex = 0;
            } else {
                this.errorIndex = 1;
            }
            return true;
        }
        if (variableAmount < 0) {
            //WRITE-DOWN
            const sameAccounts = this.stockLines.filter(
                (sl) => sl.stockAccount.inventoryAccount === inventoryStockAccount && !sl.father,
            );
            let addedWDamounts = sameAccounts.reduce(
                (partialSum, el) => partialSum + el.depreciatedAmountSigned,
                0,
            );
            addedWDamounts += this.writeDownsAmounts[inventoryStockAccount]
                ? this.writeDownsAmounts[inventoryStockAccount]
                : 0;
            // If new Line, amount not yet in stockLines
            addedWDamounts += newLine ? variableAmount : 0;
            if (addedWDamounts >= 0) {
                this.reverseError = false;
                return false;
            }
            this.reverseError = true;
            this.errorIndex = 2;
            return true;
        }
        this.reverseError = false;
        return false;
    }

    deleteRow(index, number) {
        this.stockLines.splice(index, number);
    }

    formatEditionLines(lines) {
        this.stockLines = [];

        lines.sort((l1, l2) => {
            const ref1 = l1.stockProduct?.reference || l1.unregisteredStockProduct?.reference;
            const ref2 = l2.stockProduct?.reference || l2.unregisteredStockProduct?.reference;
            if (ref1 < ref2) {
                return 1;
            }
            if (ref1 > ref2) {
                return -1;
            }
            return 0;
        });
        this.stockLines = lines.reduce((result, l, index) => {
            const invoiceProduct = l.stockProduct ? l.stockProduct : l.unregisteredStockProduct;

            if (l.storedAmountSigned) {
                result.push({
                    id: l.id ? l.id : "",
                    depreciationId: "",
                    father: false,
                    indexer: result.length,
                    childOf: null,
                    expand: false,
                    show: true,
                    invoiceProduct: {
                        title: invoiceProduct.title,
                        reference: invoiceProduct.reference,
                        id: invoiceProduct.id || "",
                        type: invoiceProduct.type || "",
                    },
                    quantity: l.quantity,
                    totalAmount: l.storedAmountSigned,
                    stockAmountSigned: l.storedAmountSigned,
                    depreciatedAmountSigned: null,
                    stockAccount: l.accountableAccount?.name
                        ? this.stock_names.find(
                              (sn) => sn.stockAccount === l.accountableAccount.name,
                          )
                        : this.defaultStockName,
                });
            }
            if (l.depreciatedAmountSigned) {
                if (
                    result[result.length - 1]?.invoiceProduct?.reference ===
                    invoiceProduct.reference
                ) {
                    // same product
                    result[result.length - 1].depreciationId = l.id;
                    result[result.length - 1].totalAmount += l.depreciatedAmountSigned;
                    result[result.length - 1].depreciatedAmountSigned = l.depreciatedAmountSigned;
                } else {
                    result.push({
                        id: l.id ? l.id : "",
                        depreciationId: "",
                        father: false,
                        indexer: result.length,
                        childOf: null,
                        expand: false,
                        show: true,
                        invoiceProduct: {
                            title: invoiceProduct.title,
                            reference: invoiceProduct.reference,
                            id: invoiceProduct.id || "",
                            type: invoiceProduct.type || "",
                        },
                        quantity: l.quantity,
                        totalAmount: l.depreciatedAmountSigned,
                        stockAmountSigned: null,
                        depreciatedAmountSigned: l.depreciatedAmountSigned,
                        stockAccount: l.accountableAccount?.name
                            ? this.stock_names.find(
                                  (sn) => sn.depreciationAccount === l.accountableAccount.name,
                              )
                            : this.defaultStockName,
                    });
                }
            }
            return result;
        }, []);

        const indexList = this.stockLines.reduce((indexes, n, i) => {
            if (
                n.stockAccount.stockAccount.startsWith("351") ||
                n.stockAccount.stockAccount.startsWith("355")
            ) {
                indexes.push(i);
            }
            return indexes;
        }, []);

        const children = [];
        for (const i of indexList) {
            this.stockLines[i].childOf = i;
            this.stockLines[i].expand = true;

            children.push(JSON.parse(JSON.stringify(this.stockLines[i])));
            children[children.length - 1].show = false;
            // Turn to father
            this.stockLines[i].father = true;
            this.stockLines[i].id = "";

            if (
                this.stockLines[i + 1]?.stockAccount.stockAccount.startsWith("331") &&
                this.stockLines[i].invoiceProduct.reference ===
                    this.stockLines[i + 1].invoiceProduct.reference
            ) {
                // Product in progress line
                this.stockLines[i + 1].childOf = i;
                this.stockLines[i + 1].show = false;
                // Add amounts
                this.stockLines[i].quantity += this.stockLines[i + 1].quantity;
                this.stockLines[i].totalAmount += this.stockLines[i + 1].totalAmount;
                this.stockLines[i].stockAmountSigned += this.stockLines[i + 1].stockAmountSigned;
                this.stockLines[i].depreciatedAmountSigned +=
                    this.stockLines[i + 1].depreciatedAmountSigned;
            } else {
                children.push({
                    id: "",
                    depreciationId: "",
                    father: false,
                    indexer: 0,
                    childOf: i,
                    expand: false,
                    show: false,
                    invoiceProduct: {
                        title: this.stockLines[i].invoiceProduct.title,
                        reference: this.stockLines[i].invoiceProduct.reference,
                        id: this.stockLines[i].invoiceProduct.id || "",
                        type: this.stockLines[i].invoiceProduct.type || "",
                    },
                    quantity: null,
                    totalAmount: null,
                    stockAmountSigned: null,
                    depreciatedAmountSigned: null,
                    stockAccount: this.stock_names.find((sn) => sn.stockAccount.startsWith("331")),
                });
            }
        }
        let count = 1;
        for (const i of indexList) {
            const itemsToPush = children.filter((ch) => ch.childOf === i);
            if (itemsToPush.length === 2) {
                this.stockLines.splice(i + count, 0, itemsToPush[0], itemsToPush[1]);
            } else {
                this.stockLines.splice(i + count, 0, itemsToPush[0]);
            }
            this.stockLines[i + count].childOf = i + count - 1;
            this.stockLines[i + count + 1].childOf = i + count - 1;
            count += itemsToPush.length;
        }
        this.stockLines.forEach((l, i) => {
            l.indexer = i;
        });
    }

    previous() {
        /*if (this.wizardStep === 0) { }
        else */
        if (this.wizardStep === 1) {
            if (this.selectedInventoryId) {
                this.wizardStep++;
            } else {
                this.wizardStep--;
                this.resetData();
            }
        } else if (this.wizardStep === 2) {
            this.resetData();
            this.wizardStep = 0;
        } else {
            this.wizardStep--;
        }
    }

    isSaving = false;
    async saveInventory() {
        this.isSaving = true;
        const result = await this.$apollo.mutate({
            mutation: INVENTORY_SAVE,
            variables: {
                selectedCompanyId: this.companyId,
                inventoryId: this.selectedInventoryId,
                userId: this.selectedUserId,
                date: moment(this.date).utc(true).format(),
                stockAmounts: [],
                stockLines: this.stockLines,
                accountingClosing: this.selectedAccountingClosing,
                accountingPeriod: this.selectedAccountingPeriod,
            },
        });

        if (result?.data?.inventoryDraft) {
            const inventoryId = result.data.inventoryDraft.inventory?.id;
            this.selectedInventoryId = inventoryId;
            if (this.$apollo.queries && this.$apollo.queries.inventories) {
                this.$apollo.queries.inventories.refetch();
            }
        }
        this.isSaving = false;
        // this.resetData()
        this.$nextTick(() => {
            this.wizardStep = 2;
        });
        this.$emit("refresh");
    }

    validateInventory() {
        this.dialogConfirmInventory = true;
    }

    async confirmInventory() {
        // Verify if inventoryId is set
        if (!this.selectedInventoryId) {
            console.error("Validation impossible : aucun ID d'inventaire trouvé");
            return;
        }
        const result = await this.$apollo.mutate({
            mutation: INVENTORY_VALIDATE,
            variables: {
                inventoryId: this.selectedInventoryId,
            },
        });
        if (result?.data?.validateInventory?.documentId) {
            this.refreshSelectedStatus();
        }
    }

    async printFromBackend() {
        this.downloadLoading = true;
        if (this.selectedInventoryId && this.selectedStatus.value !== "VALIDATED") {
            // await this.saveInventory();
        }
        // if (this.invoice?.signedUrl) {
        //     window.open(this.invoice.signedUrl, '_blank')
        //     this.downloadLoading = false
        //     return
        // }
        axios
            .get(
                `${env.VUE_APP_BACKEND}/document/print/stockInventory/${
                    this.selectedInventoryId
                }/pdf?dt="${new Date().getTime()}`,
                {},
            )
            .finally(() => (this.downloadLoading = false));
        //window.open(`${env.VUE_APP_BACKEND}/document/print/invoice/${this.invoice.id}/pdf?dt="${new Date().getTime()}`, '_blank')
    }

    async printInventory() {
        if (this.selectedStatus.value === "DRAFT") {
            const tempPreviewValue = this.showDocumentPreview;
            this.showDocumentPreview = true;

            const interval = setInterval(async () => {
                if (this.$refs.invoicePreviewRef && this.invoiceDomInfo) {
                    this.showDocumentPreview = tempPreviewValue;
                    await this.$nextTick();
                    this.printPreview();
                    this.showDocumentPreview = tempPreviewValue;
                    clearInterval(interval);
                }
            }, 200);

            setTimeout(() => {
                // Clear interval if not cleared after 2 seconds
                this.showDocumentPreview = tempPreviewValue;
                clearInterval(interval);
            }, 2000);
        } else {
            await this.printFromBackend();
        }
    }

    printPreview() {
        const htmlService = new InventoryListHtmlBuilder(
            true,
            this.invoiceThemeSettings,
            this.previewData,
            null,
            this.companyFullData,
            1,
            true,
            this.backgroundImage,
            "",
            this.invoiceDomInfo,
        );
        const html = htmlService.generateHtmlTemplate();
        // InvoiceThemeService.
        this.previewInvoiceInNewWindow({
            printingHtml: html,
            printDialog: true,
        });
    }

    previewInvoiceInNewWindow({ printingHtml, printDialog = false }) {
        if (!printingHtml) {
            return;
        }
        try {
            // if (openWindow)
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
            );
            if (WinPrint) {
                WinPrint.document.write(printingHtml);
                if (printDialog) {
                    WinPrint.onload = () => {
                        WinPrint.print();
                    };
                }

                WinPrint.document.close();
            }
        } catch (err) {
            debugger;
            console.error("Error in invoiceHtmlService.ts < previewInvoiceInNewWindow", err);
        }
    }

    disabledDownload() {
        return false;
    }

    resetData() {
        this.stockLines = [];
        this.selectedUserId = "";
        this.selectedInventoryId = "";
        this.newStockLine = JSON.parse(JSON.stringify(this.emptyStockLine));
        this.reverseError = false;
        this.selectedStatus = { value: "DRAFT", text: "Brouillon" };
    }

    onDateChanged(date) {
        // modifier les dates de chaque lignes
        // this.latestDate = date
    }

    @Apollo({
        query: INVOICE_THEMES,
        variables() {
            return {
                company: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        async specificResult({ data, loading }: any) {
            if (!loading) {
                if (
                    data?.invoiceThemes?.length &&
                    data.invoiceThemes[0].id &&
                    data.invoiceThemes[0].theme
                ) {
                    // // Necessary to unstructure the default value first so that new keys that are added to defaultInvoiceThemeSettings are also available in the loaded personnalized theme
                    // this.invoiceThemeSettings = {...this.invoiceThemeSettings, ...data.invoiceThemes[0].theme}
                    // // For compatibility with previous versions, we check if invoiceThemeSettings.tables.header.columns is null/undefined
                    // if (!this.invoiceThemeSettings.tables.header.columns) {
                    //     // Set to default value
                    //     this.invoiceThemeSettings.tables.header.columns = JSON.parse(JSON.stringify(InvoiceThemeService.getDefaultTableColumns()))
                    // }

                    this.invoiceThemeSettings = InvoiceThemeFrontService.mergeWithDefaultSettings(
                        data.invoiceThemes[0].theme,
                    );
                    this.idTheme = data.invoiceThemes[0].id;
                    if (
                        data.invoiceThemes[0].background?.signedUrl &&
                        !this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
                        this.invoiceThemeSettings?.page?.useBackgroundImage
                    ) {
                        this.backgroundImage = data.invoiceThemes[0].background.signedUrl;
                    } else {
                        await this.fetchBackgroundImage();
                    }
                    if (data.invoiceThemes[0].additionalDocument?.signedUrl) {
                        this.additionalDocument =
                            data.invoiceThemes[0].additionalDocument.signedUrl;
                    } else {
                        await this.fetchAdditionalDocument();
                    }
                }
            }
        },
    })
    invoiceThemeSettings = InvoiceThemeFrontService.originalTheme();

    idTheme = null;
    backgroundImage = null;
    additionalDocument = null;

    async fetchBackgroundImage() {
        if (!this.invoiceThemeSettings?.page?.useBackgroundImage) {
            // Don't fetch if background is not used
            return;
        }
        if (this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
            this.backgroundImage = (
                await InvoiceThemeFrontService.fetchDefaultBackground(
                    this.invoiceThemeSettings.page.selectedDefaultBackgroundKey,
                )
            )?.signedUrl;
        } else {
            if (!this.idTheme || this.idTheme.length === 0) {
                this.backgroundImage = null;
                return;
            }

            const response = await this.$apollo.query({
                query: GET_INVOICE_THEME_BACKGROUND,
                variables: {
                    id: this.idTheme,
                },
            });

            if (!response?.data?.getInvoiceThemeBackground?.signedUrl) {
                this.backgroundImage = null;
                return;
            }
            if (!this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
                this.backgroundImage = response.data.getInvoiceThemeBackground.signedUrl;
            }
        }
    }

    async fetchAdditionalDocument() {
        if (!this.idTheme || this.idTheme.length === 0) {
            this.additionalDocument = null;
            return;
        }

        const response = await this.$apollo.query({
            query: GET_INVOICE_ADDITIONAL_DOCUMENT,
            variables: {
                id: this.idTheme,
            },
        });

        if (!response?.data?.getInvoiceThemeAdditionalDocument?.signedUrl) {
            this.additionalDocument = null;
            return;
        }
        this.additionalDocument = response.data.getInvoiceThemeAdditionalDocument.signedUrl;
    }

    @Apollo({
        query: gql`
            query company($companyId: ID!) {
                company(where: { id: $companyId }) {
                    id
                    invoiceTextPaymentDetails
                    invoiceTextLegalNotices
                    name
                    siren
                    vatNumber
                    legalForm
                    shareCapital
                    registrationTown
                    logo {
                        id
                        key
                        signedUrl
                    }
                    activities {
                        id
                        name
                        description
                    }
                    address
                    postalCode
                    city
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data && data.company) {
                this.companyFullData = data.company;
                this.companyFullData.invoiceTextPaymentDetails =
                    this.companyFullData.invoiceTextPaymentDetails ??
                    this.$t("invoice.paymentDetails");
                this.companyFullData.invoiceTextLegalNotices =
                    this.companyFullData.invoiceTextLegalNotices ?? this.defaultLegalForm;
            } else {
                this.company = {
                    id: "",
                    invoiceTextPaymentDetails: "",
                    invoiceTextLegalNotices: "",
                    name: "",
                    siren: "",
                    vatNumber: "",
                    shareCapital: 0,
                    registrationTown: "",
                    activities: [],
                    logo: {
                        signedUrl: "",
                    },
                    address: "",
                    postalCode: "",
                    city: "",
                };
            }
        },
    })
    companyFullData: any = {};

    deleteInventoryLoading = false;
    deleteInventoryDialog = false;
    inventoryToDeleteId = "";

    refreshSelectedStatus() {
        if (this.$apollo.queries.selectedStatus) {
            this.$apollo.queries.selectedStatus.refetch();
        }
    }

    selectInventoryForDeletion(inventory) {
        if (inventory?.id) {
            this.inventoryToDeleteId = inventory.id;
            this.deleteInventoryDialog = true;
        }
    }

    async deleteInventory(inventoryId) {
        if (!inventoryId) return;
        this.deleteInventoryLoading = true;
        const response = await this.$apollo.mutate({
            mutation: DELETE_INVENTORY,
            variables: { inventoryId: inventoryId },
        });
        if (response.data?.deleteInventory?.success) {
            const index = this.inventories?.findIndex((el) => el.id === inventoryId) ?? -1;
            if (index >= 0) {
                this.inventories.splice(index, 1);
            }
        }
        this.deleteInventoryLoading = false;
        this.deleteInventoryDialog = false;
        this.inventoryToDeleteId = "";
    }
}

export default toNative(InventoryWizard);
</script>

<style lang="scss">
.righted-input input {
    font-size: 0.8em;
    text-align: end;
}

.no-padding {
    padding: 0px;
}

.strong-border tr:last-child {
    border-top: 2px solid black;
}
</style>
